import PanelControl from "./PanelControl.js"

export default class SettingsButton extends PanelControl {

  constructor(props, context) {
    super(props, context)
    this.classList.add("amp-settings", true)
    this.state.altText = "MSG_SETTINGS"
  }

  static get contextTypes() {
    return super.contextTypes
  }
}
